import { endpoints, baseurl } from "../Utils/Constants";

export const getAllStaffs = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_STAFFS, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staff members:', error);
        throw error;
    }
};

export const getAllStaffNames = async (token, clientId) => {
    try {
        const query = clientId ? `?client_id=${encodeURIComponent(clientId)}` : '';
        const response = await fetch(`${baseurl}${endpoints.GET_ALL_STAFF_NAMES}${query}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staff names:', error);
        throw error;
    }
};

export const getStaffById = async (staffId, token) => {
    try {
        const response = await fetch(`${baseurl + endpoints.GET_STAFF_BY_ID}${staffId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching staff member:', error);
        throw error;
    }
};

export const saveStaff = async (staffData, token) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_STAFF, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(staffData)
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error saving staff member:', error);
        throw error;
    }
};

export const deleteStaff = async (staffId, token) => {
    try {
        const response = await fetch(`${baseurl + endpoints.DELETE_STAFF}${staffId}`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error deleting staff member:', error);
        throw error;
    }
};
